var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isInIframe
    ? _c(
        "div",
        {
          staticClass: "sidebar-logo-container",
          class: { collapse: _vm.collapse },
        },
        [
          _c(
            "transition",
            { attrs: { name: "sidebarLogoFade" } },
            [
              _c("router-link", { attrs: { to: "/" } }, [
                _c("img", {
                  staticClass: "image",
                  staticStyle: { width: "105px", "margin-top": "10px" },
                  attrs: { src: require("@/assets/images/logo3.png") },
                }),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }